export default "__VITE_ASSET__d34fa14c__"